/**
 * Reactive controller that subscribes to a slice of the __VPV store.
 *
 * Usage:
 *
 *   import { VPVStoreController } from './vpv-store-controller.js';
 *
 *   class MyElement extends LitElement {
 *     _picker = new VPVStoreController(
 *       this,
 *       s => s.productVehiclePickerOpen,
 *       (isOpen) => { this.pickerOpen = isOpen; }
 *     );
 *   }
 *
 * The controller cleans up the subscription automatically when the element
 * disconnects, and re-subscribes when it reconnects.
 *
 * If no callback is provided the controller calls host.requestUpdate()
 * whenever the selected value changes — useful when you just want to read
 * from window.__VPV.store inside render().
 */
export class VPVStoreController {
  #host;
  #selector;
  #callback;
  #unsub = null;

  constructor(host, selector, callback) {
    this.#host = host;
    this.#selector = selector;
    this.#callback = callback ?? (() => {});
    host.addController(this);
  }

  hostConnected() {
    this.#unsub = window.__VPV.watch(this.#selector, (newVal, oldVal, store) => {
      this.#callback(newVal, oldVal, store);
      this.#host.requestUpdate();
    });
  }

  hostDisconnected() {
    this.#unsub?.();
    this.#unsub = null;
  }
}
